// src/utils/brightenColor.js
// Boosts a '#rrggbb' hex color's saturation and lightness (HSL space) so a
// hover glow reads as more vivid than the flat base color, instead of just
// a lighter/washed-out version of it.
export default function brightenColor(hex, lightBoost = 12, satBoost = 15) {
  const clean = (hex || '').replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16) / 255;
  const g = parseInt(clean.substring(2, 4), 16) / 255;
  const b = parseInt(clean.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s;
  const l = (max + min) / 2;
  const d = max - min;

  if (d === 0) {
    h = 0; s = 0;
  } else {
    s = d / (1 - Math.abs(2 * l - 1));
    switch (max) {
      case r: h = ((g - b) / d) % 6; break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4; break;
    }
    h *= 60;
    if (h < 0) h += 360;
  }

  const l2 = Math.min(0.92, l + lightBoost / 100);
  const s2 = Math.min(1, s + satBoost / 100);

  const c = (1 - Math.abs(2 * l2 - 1)) * s2;
  const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  const m = l2 - c / 2;
  let r2, g2, b2;
  if (h < 60)       { r2 = c; g2 = x; b2 = 0; }
  else if (h < 120) { r2 = x; g2 = c; b2 = 0; }
  else if (h < 180) { r2 = 0; g2 = c; b2 = x; }
  else if (h < 240) { r2 = 0; g2 = x; b2 = c; }
  else if (h < 300) { r2 = x; g2 = 0; b2 = c; }
  else              { r2 = c; g2 = 0; b2 = x; }

  const toByte = v => {
    const hex = Math.round((v + m) * 255).toString(16).padStart(2, '0');
    return hex;
  };
  return `#${toByte(r2)}${toByte(g2)}${toByte(b2)}`;
}
